

import AnimatedPage from "../../components/animatedPage/AnimatedPage";

const CustomerJobs = () => {
    return (
        <AnimatedPage>
            <div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8">
                <dl className="flex flex-col items-center justify-center mt-20">
                    <svg xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-10 h-10 text-gray-400">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.867 19.125h.008v.008h-.008v-.008z" />
                    </svg>

                    <span className="text-gray-400 text-sm">Work In progress...</span>
                </dl>

            </div>
        </AnimatedPage>
    )
}

export default CustomerJobs;